import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Injectable({
    providedIn: "root",
})
export class TextToSpeechService {
    audio: string;
    audioBlobUrl: any;
    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }



    getOutput(text) {
        const key = "AIzaSyAAYV5DVFzRQHIiqKKNBAS7JXfRh-pEirA";
        const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${key}`;
        const params = {
            input: { text },
            voice: {
                name: "en-US-Standard-B",
                languageCode: "en-US",
                ssmlGender: "FEMALE",
            },
            audioConfig: { audioEncoding: "MP3" },
        };
        this.http.post(url, params).subscribe((response: any) => {
            this.audio = "data:audio/mpeg;base64," + response.audioContent;
            this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(this.audio);
        });

        return this.audioBlobUrl


    }
}